import React from 'react'
import PropTypes from 'prop-types'

import { CheckoutSection } from '../../components'
import { notifyError } from '../UserMessaging'
import { Fade } from '../../componentAnimations'

import isEqual from 'lodash/isEqual'
import { translateResourceString } from '../../../util/translationUtility';


const placeOrderDetailsChanged = (prevProps, newProps) => !isEqual(prevProps.Coupons, newProps.Coupons) || !isEqual(prevProps.CartItems, newProps.CartItems) || !isEqual(prevProps.SelectedShippingOptionId, newProps.SelectedShippingOptionId);


class CheckoutCoupon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: true,
            newCouponCode: ''
        };
    }

    onClickChange(e) {
        e.preventDefault();
        this.setState({ isCollapsed: !this.state.isCollapsed });
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            this.addCoupon();
        }
    }

    addCoupon() {
        if (this.state.newCouponCode && this.state.newCouponCode != '') {
            this.props.onAddCoupon(this.state.newCouponCode);
            this.setState({ newCouponCode: '' });
        } else {
            alert(translateResourceString("/Checkout/Coupons/NoPromotionCodeEntered"));
        }
    }

    componentDidUpdate(prevProps) {
        if (placeOrderDetailsChanged(prevProps, this.props)) {
            this.props.updateCoupons();
        }
    }

    render() {
        const usedCoupons = this.props.Coupons ? this.props.Coupons : [];
        const appliedCoupons = usedCoupons.map(c => {
            var key = "appliedCoupons" + c.Code;
            return (
                <div className="row my-2" key={key}>
                    <div className="col-sm-3">{c.Code}</div>
                    <div className="col-sm-3">{c.Discount}</div>
                    <div className="col-sm-3">
                        <a className="btn btn-r-red-outline" href="" onClick={(e) => { e.preventDefault(); this.props.onRemoveCoupon(c.Code) }}>
                            {translateResourceString("/Checkout/Coupons/Remove")}
                        </a>
                    </div>
                </div>
            );
        });

        return (
          <CheckoutSection label={translateResourceString("/Checkout/Coupons/SectionLabel")} hidden={false}>
                <div className="d-flex justify-content-between" onClick={(e) => this.onClickChange(e)} style={{ cursor: 'pointer' }}>
                    <span>{translateResourceString("/Checkout/Coupons/AddCouponCode")}</span>
                    {this.props.Code}
                    {
                        (this.state.isCollapsed)
                            ? (<a href=""><i className="fas fa-caret-down"></i></a>)
                            : (<a href=""><i className="fas fa-caret-up"></i></a>)
                    }
                </div>
                <Fade inProp={!this.state.isCollapsed}>
                    <div className="coupon-body form-gray">
                        <div className="d-flex mt-1">
                            <input
                                id="newCouponCode"
                                key="newCouponCode"
                                type="text"
                                className="coupon-input form-control"
                                value={this.state.newCouponCode}
                                onChange={(e) => this.setState({ newCouponCode: e.target.value })}
                                onKeyPress={(e) => { this.onKeyPress(e) }}
                            />
                            <button
                                type="button"
                                className="btn btn-r-red ml-1"
                                onClick={() => { this.addCoupon() }}
                            >Apply</button>
                        </div>
                        {!!appliedCoupons.length && (
                            <div className="my-3 collapse-xs" id="appliedCoupons">
                                <h5 className="coupon-body__applied-list-header"><strong>{translateResourceString("/Checkout/Coupons/CouponsApplied")}:</strong></h5>
                                {appliedCoupons}
                            </div>
                        )}
                        
                    </div>
                </Fade>
            </CheckoutSection>
        );
    }
}

CheckoutCoupon.propTypes = {
    Coupons: PropTypes.array.isRequired,
    CartItems: PropTypes.array,
    SelectedShippingOptionId: PropTypes.string
}

export default CheckoutCoupon
